import {
    Box,
    Container,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../../../component/Header/Header";
import PortalNavbar from "../../../component/PortalNavbar/PortalNavbar";

const useStyles = makeStyles({
    root: {
        width: "85%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
});

function MaintenanceTime() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");

    function createData(key, date, timeFrom, timeTo, affectedService) {
        return { key, date, timeFrom, timeTo, affectedService };
    }

    const rows = [
        createData(1, "2021-08-13", "06:00", "23:00", "Form Filling"),
        createData(2, "2021-08-16", "08:00", "17:00", "Form Query"),
    ];

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.maintenanceTime")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <main Box className="main">
                    <Typography
                        variant="subtitle1"
                        style={{ fontWeight: "bold" }}
                        align="center"
                        component="h1"
                    >
                        {t("common.portal.uatNotice")}
                        <br />
                    </Typography>
                    <TableContainer
                        component={Paper}
                        className={matches ? classes.root : classes.rootMobile}
                    >
                        <Table arial-label="maintenance time table">
                            <TableHead className={classes.header}>
                                <TableRow>
                                    <TableCell
                                        rowSpan={2}
                                        align="center"
                                        style={{ fontWeight: "bold" }}
                                    >
                                        {t("common.date")}
                                    </TableCell>
                                    <TableCell
                                        colSpan={2}
                                        align="center"
                                        style={{ fontWeight: "bold" }}
                                    >
                                        {t("common.time")}
                                    </TableCell>
                                    <TableCell
                                        rowSpan={2}
                                        align="center"
                                        style={{ fontWeight: "bold" }}
                                    >
                                        {t("common.affectedService")}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        style={{ fontWeight: "bold" }}
                                    >
                                        {t("common.from")}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ fontWeight: "bold" }}
                                    >
                                        {t("common.to")}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row) => (
                                    <TableRow key={row.key}>
                                        <TableCell align="center">
                                            {row.date}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.timeFrom}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.timeTo}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.affectedService}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </main>
            </Box>
        </Container>
    );
}
export default MaintenanceTime;
